var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Avatar") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 10.87a6.34 6.34 0 001.88-4.51c0-3.51-2.85-6.36-6.36-6.36-3.51 0-6.36 2.85-6.36 6.36 0 3.51 2.85 6.36 6.36 6.36H14c3.31 0 6.01 2.7 6.01 6.01v.66c0 .34-.28.61-.62.61H2.61c-.34 0-.61-.28-.61-.61v-.66c0-1.87.85-3.61 2.33-4.75.44-.34.52-.97.18-1.4a.993.993 0 00-1.4-.18A7.953 7.953 0 000 18.74v.66c0 1.44 1.17 2.61 2.61 2.61h16.77A2.62 2.62 0 0022 19.4v-.66c0-3.9-2.8-7.15-6.5-7.86v-.01zM6.65 6.36C6.65 3.96 8.61 2 11.01 2c2.4 0 4.36 1.96 4.36 4.36 0 2.4-1.96 4.36-4.36 4.36a4.37 4.37 0 01-4.36-4.36z",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/Avatar.bcd73620325d0b223f3cb1aaccd8e683.svg";
export { ForwardRef as ReactComponent };